import { useSearchParams } from 'react-router-dom'

const UUID_FILTERACTION_PARAM = 'uuid_filteraction'

const useDefaultExecutedFilteraction = (
  defaultExecutedFilteraction?: string
): string => {
  const [searchParams] = useSearchParams()
  const filteractionFromQueryParams =
    searchParams.get(UUID_FILTERACTION_PARAM) || ''
  return defaultExecutedFilteraction || filteractionFromQueryParams
}

export default useDefaultExecutedFilteraction
